import api from "@/services/axios.js";
import { ResendVerificationCodeRequest } from "../../types.ts";

export const resendVerificationCode = (form: ResendVerificationCodeRequest) =>
  api.post("/api/AdminVerification/resend-verification-message", form);
